export const CHART_TOOLTIP_CLASS = 'relative-chart-tooltip';

export const CHART_TOOLTIP_VIEWPORT_MARGIN = 100;

export const CHART_TOOLTIP_HORIZONTAL_OFFSET = 50;

export const CHART_TOOLTIP_BG_OVER_GRAPH = 'rgba(255, 255, 255, 0.8)';

export const CHART_TOOLTIP_BG_OVER_LEGEND = 'rgba(255, 255, 255, 1)';
